module.exports = __webpack_public_path__ + "static/media/nologo.1f251911.png";